<template>
  <div class="upload">
    <div class="imgbox" @click="upload" @mouseenter="imgboxHover" @mouseleave="imgboxLeave">
      <input type="file" class="input" @change="fileChange" ref="imgUploader" />
      <img :src="require('@/assets/img/icon_upload.png')" class="uploadIcon" alt="" />
      <div class="preview">
        <img :src="preview" alt="" />
      </div>
      <div class="wrap" v-show="wrapShow">
        <div class="handlerArea">
          <div class="zoom">
            <i @click.stop="zoom" class="el-icon-zoom-in"></i>
          </div>
          <div class="delete" v-show="!disabled">
            <i @click.stop="del" class="el-icon-delete"></i>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="preview" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { fileDomain } from '@/util/index';
console.log(fileDomain());

export default {
  data() {
    return {
      preview: '',
      wrapShow: false,
      dialogVisible: false,
      deleteShow: false
    };
  },
  props: {
    size: {
      required: false,
      type: String,
      default: '100000'
    },
    // 是否可以操作
    disabled: {
      type: Boolean
    }
  },
  methods: {
    del() {
      this.preview = '';
      this.wrapShow = false;
      this.$refs.imgUploader.value = '';
    },
    zoom() {
      // 放大
      this.dialogVisible = true;
    },
    imgboxHover() {
      if (this.preview) {
        this.wrapShow = true;
      }
    },
    imgboxLeave() {
      this.wrapShow = false;
    },

    upload() {
      if (this.disabled) {
        return;
      }
      this.$refs.imgUploader.click();
    },
    fileChange() {
      // 上传文件
      if (!window.FormData) {
        this.$message.error('您当前浏览器不支持图片上传，请更换为360极速浏览器');
        return;
      }

      const _this = this;
      let upload = this.$refs.imgUploader;
      const file = upload.files[0]; // File对象
      if (!file) {
        // 用户取消了本次操作
        return;
      }
      let { size } = file;
      // if (size < this.size) {
      //   // 检测图片大小
      //   this.$message.error('上传图片过大');
      //   return;
      // }
      let fd = new FormData();
      fd.append('file', file);
      Fetch.uploadFile(fd)
        .then(res => {
          if (res.data.ok) {
            let fl = fileDomain();
            _this.preview = `${fl}${res.data.result.relativePath}`;
            // _this.preview = res.data.result.fullPath;
            this.$message('上传成功');
          } else {
            this.$message.error('上传失败，请重试');
          }
        })
        .catch(e => {
          this.$message.error('上传失败，请重试');
        });

      /* const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onprogress = function (e) {
        if (e.lengthComputable) {
          // 简单把进度信息打印到控制台吧
          console.log(e.loaded / e.total + '%');
        }
      };
      reader.onload = function (e) {
        _this.preview = e.target.result;
        let fd = new FormData();
        fd.append('file', file);
        Fetch.uploadFile(fd).then(res => {

        });
      };
      reader.onerror = function (e) {
        console.log('there is an error!');
      }; */
    },
    getUploadImg() {
      let fl = fileDomain();
      return this.preview.split(fl)[1];
    },
    setImg(url) {
      let fl = fileDomain();
      this.preview = /^https?:\/\//.test(url) ? url : `${fl}${url}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.imgbox {
  background-color: #fbfdff;
  border: 1px dashed rgba(189, 189, 189, 1);
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  line-height: 146px;
  vertical-align: top;
  cursor: pointer;
  position: relative;
  &:hover {
    border-color: #1e8dff;
  }
  .uploadIcon {
    display: block;
    margin-top: 50px;
    margin-left: 40px;
  }
  .input {
    display: none;
  }
  .preview {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 3;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    z-index: 4;
    top: 0;
    left: 0;
    .handlerArea {
      overflow: hidden;
      .base {
        float: left;
        i {
          font-size: 20px;
          color: #fff;
        }
      }
      .zoom {
        @extend .base;
        margin-left: 50px;
      }
      .delete {
        @extend .base;
        margin-left: 10px;
      }
    }
  }
}
</style>
